import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'app-state-indicator',
    templateUrl: './state-indicator.component.html',
    styleUrls: ['./state-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false
})
export class StateIndicatorComponent {

    // Inputs.
    @Input() state: string | null = null;
    @Input() message: string | null = null;

}
